module.exports = __webpack_public_path__ + "img/sintesis.feb6641f.svg";